module.exports = __webpack_public_path__ + "static/raj-c25f4b50e75791eb92ec6419241a6373.jpg";